import Grid from '@mui/material/Grid';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Fragment } from 'react';

interface ISteppedSectionHeaderProps extends BoxProps {
    activeStep: number;
    steps: PropTypes[];
}
interface PropTypes {
    title: string;
    completed: boolean;
}
function SteppedSectionHeader({
    steps,
    activeStep,
    ...other
}: ISteppedSectionHeaderProps) {
    return (
        <Box {...other}>
            <Grid container width="100%" alignItems="center" gap={{ sm: 4, xs: '16px' }}>
                {steps.map((step, index) => (
                    <Fragment key={index}>
                        <Grid item flexGrow={1}>
                            <Divider
                                sx={{
                                    backgroundColor: step.completed
                                        ? '#5B5B5B'
                                        : '#EDEDED',
                                    height: { sm: 8, xs: 6 },
                                    borderRadius: 4,
                                    border: 'none'
                                }}
                            />
                            <Typography
                                mt={0.75}
                                fontSize={{ sm: 16, xs: 14 }}
                                fontWeight={step.completed ? 700 : 400}
                                color={step.completed ? '#5B5B5B' : '#999999'}
                            >
                                {step.title}
                            </Typography>
                        </Grid>
                    </Fragment>
                ))}
            </Grid>
        </Box>
    );
}

export default SteppedSectionHeader;
